<template>
  <b-card no-body>
    <b-card-header>
      <!-- title and subtitle -->
      <div>
        <b-card-title class="mb-1">
          Ref Finance Traffic
        </b-card-title>
        <b-card-sub-title>Daily Transactions</b-card-sub-title>
      </div>
    </b-card-header>

    <!-- chart -->
    <b-card-body>
      <vue-apex-charts
        v-if="loaded"
        type="area"
        height="250"
        :options="apexChartData.refTrafficChart.chartOptions"
        :series="apexChartData.refTrafficChart.series"
      />
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardBody, BCardHeader, BCardTitle, BCardSubTitle, BCardText,
} from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import apexChartData from './apexChartData'
import axios from 'axios'

export default {
  components: {
    BCard,
    BCardBody,
    BCardHeader,
    BCardTitle,
    BCardSubTitle,
    BCardText,

    VueApexCharts,
  },
  data() {
    return {
      loaded: false,
      apexChartData,
    }
  },
  methods: {
  },
  mounted () {
    this.loaded = false
    // query Traffic Data
    const trafficEndpoint = 'https://node-api.flipsidecrypto.com/api/v2/queries/972f2024-4242-460b-bcbf-5402cd8e5f59/data/latest'
    axios.get(trafficEndpoint)
    .then(response => {
      apexChartData.refTrafficChart.series[0].data = []
      for (let datapoint in response.data){
        var x = new Date(response.data[datapoint].DATE)
        var y = response.data[datapoint].TOT
        if(response.data[datapoint].LABEL == 'Ref Finance'){
          apexChartData.refTrafficChart.series[0].data.push({
            x: x,
            y: y
          })
        }
      }
      this.loaded = true;
    })
    .catch(e => {
      console.error(e)
    })
  }
}
</script>
